module.exports = __webpack_public_path__ + "img/board-4874863_960_720.750d50d7.jpg";